import { ReactNode } from "react"
import { Box, BoxProps, HStack, Image, ImageProps } from "@chakra-ui/react"

type DepositCarouselModalHeaderProps = BoxProps & {
  imageSrc?: string
  imageProps?: ImageProps
  children: ReactNode
}

export default function DepositCarouselModalHeader({
  imageSrc,
  imageProps,
  children,
  ...props
}: DepositCarouselModalHeaderProps) {
  return (
    <Box
      borderRadius="1.5rem 1.5rem 0 0"
      bg="stbtc.yellowGradient"
      h="145px"
      p="36px 48px"
      color="primary.black.100"
      {...props}
    >
      <HStack justifyContent="space-between" alignItems="center" h="100%">
        {children}
        {imageSrc && <Image src={imageSrc} {...imageProps} />}
      </HStack>
    </Box>
  )
}
